import React from "react"
import { Box } from "@mui/material"
import { IEvent, IEventScoreBoard, IEventScoreBoardResult } from "bets.oddprovider.lib.common.ts/models"
import { EventScoreBoardResultComponent } from "./eventScoreBoardResult"

export const EventScoreBoardComponent: React.FC<{
  eventScoreBoard: IEventScoreBoard,
  event: IEvent,
  onChangeResult?: (eventScoreBoard: IEventScoreBoard, result: IEventScoreBoardResult) => void
}> = ({ eventScoreBoard, event, onChangeResult }) => {
  return (
    <Box display="flex" flexWrap="wrap" gap={'20px'}>
      {eventScoreBoard.result.map((i, idx) => (
        <EventScoreBoardResultComponent
          key={idx}
          onChangeResult={(e) => onChangeResult?.(eventScoreBoard, e)}
          result={i}
          event={event}
        />
      ))}
    </Box>
  )
}
